// frontend/src/components/ThemePickerDialog/index.jsx
// Seletor de temas em grade, agrupado. Clique aplica na hora (preview vivo).
import React from "react";
import PropTypes from "prop-types";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, ButtonBase, Typography, Box,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useThemeContext, THEME_OPTIONS } from "../../context/DarkMode";

const GROUPS = [
  { id: "basicos",   label: "Básicos" },
  { id: "naturezas", label: "Naturezas" },
  { id: "vibes",     label: "Vibes" },
  { id: "especiais", label: "Especiais" },
];

const ThemePickerDialog = ({ open, onClose }) => {
  const { theme: current, setTheme } = useThemeContext();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Escolha seu tema</DialogTitle>
      <DialogContent dividers>
        {GROUPS.map((g) => {
          const opts = THEME_OPTIONS.filter((o) => o.group === g.id);
          if (!opts.length) return null;
          return (
            <Box key={g.id} sx={{ mb: 2 }}>
              <Typography variant="overline" color="text.secondary">{g.label}</Typography>
              <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))", gap: 1, mt: 0.5 }}>
                {opts.map((opt) => (
                  <ButtonBase
                    key={opt.id}
                    onClick={() => setTheme(opt.id)}
                    aria-pressed={current === opt.id}
                    sx={{
                      borderRadius: 2, p: 1.2, flexDirection: "column", gap: 0.5,
                      border: "2px solid",
                      borderColor: current === opt.id ? "primary.main" : "divider",
                    }}
                  >
                    <Box sx={{
                      width: "100%", height: 44, borderRadius: 1, position: "relative",
                      backgroundColor: opt.swatch, border: `1px solid ${opt.border}`,
                      display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20,
                    }}>
                      <span>{opt.emoji}</span>
                      {current === opt.id && (
                        <CheckCircleIcon color="primary" sx={{ position: "absolute", top: 2, right: 2, fontSize: 16, background: (t) => t.palette.background.paper, borderRadius: "50%" }} />
                      )}
                    </Box>
                    <Typography variant="body2">{opt.label}</Typography>
                  </ButtonBase>
                ))}
              </Box>
            </Box>
          );
        })}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
};

ThemePickerDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default ThemePickerDialog;
